require('./accountsBuyAmazonGiftCardStep2.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
const WebappRender = require('components/conditionalRender/webappRender')
// @Contact Center components
const {
    ConfirmationScript,
    CONFIRMATION_SCRIPT_GREETING,
    CONFIRMATION_SCRIPT_AGREEMENT
} = require('components/contactCenter/confirmScript/confirmationScript');
// @helper
const PersonalDataHelper = require('utilities/personalDataHelper');
const { FormattedText, formatText} = require('core/i18n').i18n;

//@constants
const { EURO_TEXT } = require('constants/index');
const {
    ACCOUNT_BUY_AMAZON_GIFT_CARD_PURCHASE_ID,
    MULTIPLE_OPERATIONS,
    TRANSFER_SEPA_NATIONAL_ID,
} = require('constants/operationTypes');
const {
    AMAZON_TERMS_AND_CONDITIONS_PDF_FILE_NAME,
} = require('constants/accountAmazonGiftCard');
const { 
    AMAZON_PROMOCIONES_STEP_TWO,
    AMAZON_GIFT_CARD_TIPO_PROCESS
 } = require('constants/tagging');
//@utils
const {
    recordPath
} = require("utilities/tagging");

const AmazonGiftCardDetails = require('components/accounts/accountsBuyAmazonGiftCard/amazonGiftCardDetails/amazonGiftCardDetails');

class AccountsBuyAmazonGiftCardStep2 extends React.Component {

    componentDidMount() {
        const { requestPDFMerge } = this.props;
        requestPDFMerge({'url': formatText('buyAmazonGiftCardStep2-termsAndConditionsPdfLink')});
        recordPath(AMAZON_PROMOCIONES_STEP_TWO, '', AMAZON_GIFT_CARD_TIPO_PROCESS, "paso 2");
    }

    render() {
        const {
            accountBuyAmazonGiftCard,
            handlePreContractCheckboxChange,
            immAccounts,
            immPdfData,
            immProfile,
            immSteps,
        } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const accountSelected = immSteps && immSteps.getIn(['0','accountSelected']);
        const amount = immSteps && immSteps.getIn(['0','giftVoucherAmount']);
        const operative = formatText('amazonGiftCard-operativeName');
        const pdfError = immPdfData.get('errorContent');
        const isCheckboxChecked = immSteps && immSteps.getIn(['1', 'isPreContractCheckboxChecked']);
        let agreementCheckboxContent;
        let signaturePatternContent;
        
        let operationType = MULTIPLE_OPERATIONS;
        let operationParams = {
            "id": 34,
            "requestMulti": [
                {
                    serviceCode: TRANSFER_SEPA_NATIONAL_ID,
                    currency: EURO_TEXT,
                    ammount: amount,
                    destinationAccount: accountBuyAmazonGiftCard.get('destinationAccount'),
                    originAccount: immAccounts.getIn(['byId',accountSelected,'fullContractNumber'])
                },
                {
                    serviceCode: ACCOUNT_BUY_AMAZON_GIFT_CARD_PURCHASE_ID
                }
            ]
        }


        const preContractInfo = {
            preContractPdfLink: [
                {
                    url: formatText('buyAmazonGiftCardStep2-termsAndConditionsPdfLink')
                }
            ],
            preContractPdfFileName: AMAZON_TERMS_AND_CONDITIONS_PDF_FILE_NAME
        }

        if (!pdfError) {
            const checkboxLabel = (
                <FormattedText value={'buyAmazonGiftCardStep2-termsAndConditionsCheckboxText'}/>
            );
            agreementCheckboxContent = (
                <div className="accounts-buy-amazon-gift-card-step2__checkbox-container">
                    <WebappRender>
                        <OKCheckbox
                            idName="hireAmazonGCTermsAndConditions"
                            label={checkboxLabel}
                            onChange={handlePreContractCheckboxChange}
                            value={isCheckboxChecked}
                        />
                    </WebappRender>
                </div>
            )
        }

        if ((!__CONTACT_CENTER__ && isCheckboxChecked) || __CONTACT_CENTER__) {
            signaturePatternContent = (
                <SignaturePattern
                    operationType={operationType}
                    operationParams={operationParams}
                />
            )
        }

        return (
            <div className="accounts-buy-amazon-gift-card-step2">
                <div id="printable-wizard">
                    <h2 className="accounts-buy-amazon-gift-card-step2__title">
                        <FormattedText className="" value={'buyAmazonGiftCardStep2-title'}
                        />
                    </h2>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    <div className="accounts-buy-amazon-gift-card-step2__subtitle">
                        <FormattedText
                            value={'buyAmazonGiftCardStep2-subTitle'}
                        />
                    </div>
                    <AmazonGiftCardDetails
                        immSteps={immSteps}
                        immAccounts={immAccounts}
                        columnCount={2}
                        showEmailLabel={true}
                        email={email}
                    />
                </div>

                <WebappRender>
                    <div className="accounts-buy-amazon-gift-card-step2__pdf-viewer-container">
                        <PreContractualDocumentViewer
                            preContractDocumentInfo={preContractInfo}
                            titleKey="preContractDocument_amazonGiftCardPdfTitle"
                        />
                    </div>
                </WebappRender>

                {!__CONTACT_CENTER__ && agreementCheckboxContent}

                <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                <div className="accounts-buy-amazon-gift-card-step2__gdpr-signature-pattern">
                    {signaturePatternContent}
                </div>
            </div>
        );
    }
}

AccountsBuyAmazonGiftCardStep2.propTypes = {
    accountBuyAmazonGiftCard: PropTypes.object,
    handlePreContractCheckboxChange: PropTypes.func,
    immAccounts: PropTypes.object,
    immPdfData: PropTypes.object,
    immProfile: PropTypes.object,
    immSteps: PropTypes.object,
    printTitleValue: PropTypes.string,
    requestPDFMerge: PropTypes.func,
}

module.exports = AccountsBuyAmazonGiftCardStep2;
